import { RootState } from '../../Presentation/store';
import { Log, LogPagination } from '../Model/Log';

export const selectLogs = (s: RootState): Log[] => s.log.list;

export const selectLogLoading = (s: RootState): boolean => s.log.loading;

export const selectLogPagination = (s: RootState): LogPagination | undefined => s.log.pagination;
